import { render, staticRenderFns } from "./intro-section.vue?vue&type=template&id=163382c4&scoped=true&"
import script from "./intro-section.vue?vue&type=script&lang=js&"
export * from "./intro-section.vue?vue&type=script&lang=js&"
import style0 from "./intro-section.vue?vue&type=style&index=0&id=163382c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163382c4",
  null
  
)

export default component.exports